import { ILinkedServiceTypeMetadata } from 'app/extensibility/metadatas/resource-type/linked-service-type-metadata';

import { Metamodel } from 'app/model/base/model';
import { format } from 'app/shared/utils/string.util';
import { PowerBIWorkspaceLinkedService, shellStringResources } from 'shell-models-lib';

export const powerBIWorkspaceMetadata: ILinkedServiceTypeMetadata = {
    type: Metamodel.modelFor(PowerBIWorkspaceLinkedService).name,
    displayName: format(stringResources.PowerBI, stringResources.PowerBI),
    linkedServiceKind: 'table',
    icon: {
        className: 'svg-i-100x100-powerbi'
    },
    isFirstClass: true,
    noIR: true,
    disableQueryAPI: true,
    category: ['PowerBI'],
    copySinkTypes: [],
    copySourceTypes: [],
    controls: [
        {
            type: 'powerbi-workspace-select',
            bind: {
                workspaceID: 'workspaceID',
                tenantID: 'tenantID'
            },
            label: shellStringResources.ModelName_PowerBIWorkspaceID,
            required: true,
            validators: [
                { type: 'required', errorMessage: '' }
            ],
            isLabelVertical: true
        }
    ]
};

